import { ref } from 'vue';

// Dark by default; light on request, remembered in this browser.
const KEY = 'v5-theme';
const read = () => {
  try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
};
const theme = ref(read());

// eslint-disable-next-line import-x/prefer-default-export
export function useV5Theme() {
  const setTheme = (t) => {
    theme.value = t;
    try { localStorage.setItem(KEY, t); } catch { /* private mode: keep it for this visit */ }
  };
  return { theme, setTheme, toggle: () => setTheme(theme.value === 'dark' ? 'light' : 'dark') };
}
